const CycleIcon = ({ width = 48, height = 36, fill = '#CE181E' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.00247V2.21247C12 1.76247 11.46 1.54247 11.15 1.86247L8.35 4.65247C8.15 4.85247 8.15 5.16247 8.35 5.36247L11.14 8.15247C11.46 8.46247 12 8.24247 12 7.79247V6.00247C15.31 6.00247 18 8.69247 18 12.0025C18 12.7925 17.85 13.5625 17.56 14.2525C17.41 14.6125 17.52 15.0225 17.79 15.2925C18.3 15.8025 19.16 15.6225 19.43 14.9525C19.8 14.0425 20 13.0425 20 12.0025C20 7.58247 16.42 4.00247 12 4.00247ZM12 18.0025C8.69 18.0025 6 15.3125 6 12.0025C6 11.2125 6.15 10.4425 6.44 9.75247C6.59 9.39247 6.48 8.98247 6.21 8.71247C5.7 8.20247 4.84 8.38247 4.57 9.05247C4.2 9.96247 4 10.9625 4 12.0025C4 16.4225 7.58 20.0025 12 20.0025V21.7925C12 22.2425 12.54 22.4625 12.85 22.1425L15.64 19.3525C15.84 19.1525 15.84 18.8425 15.64 18.6425L12.85 15.8525C12.54 15.5425 12 15.7625 12 16.2125V18.0025Z"
        fill={fill}
      />
    </svg>
  );
};

export default CycleIcon;
